export enum SocialAuthEnum {
  MICROSOFT = 'microsoft',
  GOOGLE = 'google'
}
